import { useMemo } from 'react';
import { useGetSatisfyingOptionsQuery } from '../../../__generated__/chirp/com/hubspot/scopegaps/rpc/ScopeGapsService.hooks';
import { useInstallability } from '../../hooks/useInstallability';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedJSXMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function useGetTemplateInstallability({
  listingId,
  published,
  appContext = 'app',
  productType
}) {
  var _installabilityData$i, _installabilityData$i2, _installabilityData$i3, _installabilityData$i4, _installabilityData$i5, _installabilityData$i6, _installabilityData$i7, _installabilityData$i8, _installabilityData$i9, _installabilityData$i10;
  const {
    data: installabilityData,
    loading: installabilityLoading
  } = useInstallability({
    listingId,
    published,
    appContext
  });
  const missingUserScopes = (_installabilityData$i = installabilityData === null || installabilityData === void 0 || (_installabilityData$i2 = installabilityData.installability) === null || _installabilityData$i2 === void 0 || (_installabilityData$i2 = _installabilityData$i2.uninstallableReason) === null || _installabilityData$i2 === void 0 ? void 0 : _installabilityData$i2.missingUserScopes) !== null && _installabilityData$i !== void 0 ? _installabilityData$i : [];
  const missingPortalScopes = (_installabilityData$i3 = installabilityData === null || installabilityData === void 0 || (_installabilityData$i4 = installabilityData.installability) === null || _installabilityData$i4 === void 0 || (_installabilityData$i4 = _installabilityData$i4.uninstallableReason) === null || _installabilityData$i4 === void 0 ? void 0 : _installabilityData$i4.missingPortalScopes) !== null && _installabilityData$i3 !== void 0 ? _installabilityData$i3 : [];
  const allMissingScopes = [...missingUserScopes.map(scope => scope.toLowerCase().replaceAll('_', '-')), ...missingPortalScopes.map(scope => scope.toLowerCase().replaceAll('_', '-'))];
  const {
    data: missingPlanData
  } = useGetSatisfyingOptionsQuery({
    variables: {
      scopes: allMissingScopes
    },
    skip: allMissingScopes.length === 0
  });
  const missingPlanOptions = missingPlanData === null || missingPlanData === void 0 ? void 0 : missingPlanData.satisfyingOptions;
  const missingPlanTooltip = useMemo(() => {
    if (missingPlanOptions && missingPlanOptions.length === 1 && missingPlanOptions[0].and.length === 1) {
      if (missingPlanOptions[0].and[0].or.length === 1) {
        const option = missingPlanOptions[0].and[0].or[0];
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.uninstallableReasons.missingPlan",
          options: {
            planName: option.displayName,
            productType: unescapedText(`detailsPage.productType.${productType}`)
          }
        });
      }
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.productDetailsCard.cta.uninstallableReasons.missingPlans",
          options: {
            productType: unescapedText(`detailsPage.productType.${productType}`)
          }
        }), /*#__PURE__*/_jsx(List, {
          marginBlockStart: "200",
          marginInlineStart: "-400",
          styled: true,
          children: missingPlanOptions[0].and[0].or.map((option, index) => /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.productDetailsCard.cta.uninstallableReasons.orHigherTier",
              options: {
                planName: option.displayName
              }
            })
          }, index))
        })]
      });
    }
  }, [missingPlanOptions, productType]);
  return {
    loading: installabilityLoading,
    installed: (_installabilityData$i5 = installabilityData === null || installabilityData === void 0 ? void 0 : installabilityData.installed) !== null && _installabilityData$i5 !== void 0 ? _installabilityData$i5 : false,
    missingScopes: allMissingScopes,
    userInstallable: (_installabilityData$i6 = installabilityData === null || installabilityData === void 0 || (_installabilityData$i7 = installabilityData.installability) === null || _installabilityData$i7 === void 0 ? void 0 : _installabilityData$i7.userInstallable) !== null && _installabilityData$i6 !== void 0 ? _installabilityData$i6 : false,
    portalInstallable: (_installabilityData$i8 = installabilityData === null || installabilityData === void 0 || (_installabilityData$i9 = installabilityData.installability) === null || _installabilityData$i9 === void 0 ? void 0 : _installabilityData$i9.portalInstallable) !== null && _installabilityData$i8 !== void 0 ? _installabilityData$i8 : false,
    uninstallableReason: installabilityData === null || installabilityData === void 0 || (_installabilityData$i10 = installabilityData.installability) === null || _installabilityData$i10 === void 0 ? void 0 : _installabilityData$i10.uninstallableReason,
    missingPlanData,
    missingPlanTooltip
  };
}